var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TlDeskRange",class:_vm.modifiers},[_c('div',{staticClass:"TlDeskRange-text",on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.rangeText)+" ")]),_c('div',{staticClass:"TlDeskRange-bounds"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }